(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bjc-description"] && !Shopify.designMode) return;
  try {
    (function () {
    function measure(root) {
      var content = root.querySelector('[data-bjc-desc]');
      if (!content) return;
      // collapsed pixel height
      var collapsed = parseFloat(getComputedStyle(content).maxHeight);
      if (!root.classList.contains('is-open') && content.scrollHeight <= collapsed + 4) {
        root.classList.add('bjc-desc--short');
      }
    }
    function init() {
      document.querySelectorAll('.bjc-desc').forEach(measure);
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-bjc-desc-toggle]');
      if (!btn) return;
      var root = btn.closest('.bjc-desc');
      var open = root.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
